import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { RecognitionEventArgs } from "./Exports";
/**
 * Defines content of a RecognitionErrorEvent.
 * @class SpeechRecognitionCanceledEventArgs
 */

export var SpeechRecognitionCanceledEventArgs = /*#__PURE__*/function (_RecognitionEventArgs) {
  _inherits(SpeechRecognitionCanceledEventArgs, _RecognitionEventArgs);

  var _super = _createSuper(SpeechRecognitionCanceledEventArgs);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */
  function SpeechRecognitionCanceledEventArgs(reason, errorDetails, errorCode, offset, sessionId) {
    var _this;

    _classCallCheck(this, SpeechRecognitionCanceledEventArgs);

    _this = _super.call(this, offset, sessionId);
    _this.privReason = reason;
    _this.privErrorDetails = errorDetails;
    _this.privErrorCode = errorCode;
    return _this;
  }
  /**
   * The reason the recognition was canceled.
   * @member SpeechRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */


  _createClass(SpeechRecognitionCanceledEventArgs, [{
    key: "reason",
    get: function get() {
      return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */

  }, {
    key: "errorCode",
    get: function get() {
      return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member SpeechRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */

  }, {
    key: "errorDetails",
    get: function get() {
      return this.privErrorDetails;
    }
  }]);

  return SpeechRecognitionCanceledEventArgs;
}(RecognitionEventArgs);